"use client"

import type { ReactNode } from "react"
import { ErrorBoundary, ErrorFallback } from "@/components/ui/error-boundary"

interface AppErrorBoundaryProps {
  children: ReactNode
}

/**
 * Application-level error boundary wrapper for the root layout.
 * Catches unhandled errors and displays a user-friendly fallback UI.
 */
export function AppErrorBoundary({ children }: AppErrorBoundaryProps) {
  return (
    <ErrorBoundary
      fallback={
        <div className="min-h-screen flex items-center justify-center bg-slate-50">
          <ErrorFallback
            error={new Error("An unexpected error occurred")}
            onRetry={() => window.location.reload()}
          />
        </div>
      }
    >
      {children}
    </ErrorBoundary>
  )
}
